<template>
  <div class="totalWrapper">
    <div class="muarBlock"></div>
    <div class="formBlok">
      <form @submit.prevent="handleLogin" class="mx-auto p-4 bg-white rounded-4 shadow-sm">
        <div v-if="authState === 'error' && errorMessage" class="alert alert-danger" role="alert">
          {{ errorMessage }}
        </div>

        <div v-if="authState === 'loading'" class="alert alert-warning" role="alert">
          Processing your login...
        </div>

        <div v-if="authState === 'success'" class="alert alert-success" role="alert">
          Login successful! Redirecting...
        </div>

        <div class="mb-3">
          <input
            v-model="email"
            type="email"
            class="form-control form-control-lg"
            :class="{ 'is-invalid': !!getFieldError(fieldErrors, 'email') }"
            placeholder="Email"
            required
          />
          <div v-if="getFieldError(fieldErrors, 'email')" class="invalid-feedback d-block">
            {{ getFieldError(fieldErrors, 'email') }}
          </div>
        </div>
        <div class="mb-3">
          <input
            v-model="password"
            class="form-control form-control-lg"
            :class="{ 'is-invalid': !!getFieldError(fieldErrors, 'password') }"
            type="password"
            placeholder="Password"
            required
          />
          <div v-if="getFieldError(fieldErrors, 'password')" class="invalid-feedback d-block">
            {{ getFieldError(fieldErrors, 'password') }}
          </div>
        </div>

        <button type="submit" class="btn btn-dark w-100 btn-lg" :disabled="authState === 'loading'">
          Sign in
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { getFirstFieldError, normalizeApiError } from '@/utils/apiError'

const email = ref('')
const password = ref('')
const authState = ref('')
const errorMessage = ref('')
const fieldErrors = ref({})
const auth = useAuthStore()
const router = useRouter()
const route = useRoute()

function clearFeedback() {
  errorMessage.value = ''
  fieldErrors.value = {}
}

function getRedirectTarget() {
  const redirect = route.query.redirect
  if (typeof redirect === 'string' && redirect.startsWith('/')) {
    return redirect
  }
  return '/'
}

function getFieldError(errors, fieldName) {
  return getFirstFieldError(errors, fieldName)
}

onMounted(async () => {
  if (!auth.token) {
    return
  }

  clearFeedback()
  try {
    const isAuth = await auth.checkToken()
    if (isAuth) {
      await router.replace(getRedirectTarget())
    }
  } catch (e) {
    authState.value = 'error'
    errorMessage.value = 'Не вдалося перевірити поточну сесію.'
  }
})

const handleLogin = async () => {
  authState.value = 'loading'
  clearFeedback()

  try {
    await auth.login({ email: email.value, password: password.value })
    if (auth.getToken == null) {
      authState.value = 'error'
      errorMessage.value = 'Login failed.'
      return
    }
    authState.value = 'success'
    await router.replace(getRedirectTarget())
  } catch (e) {
    const apiError = normalizeApiError(e, {
      fallbackMessage: 'Не вдалося виконати вхід.',
    })

    authState.value = 'error'
    errorMessage.value = apiError.message
    fieldErrors.value = apiError.fieldErrors
  }
}

</script>
<style scoped lang="scss">

.totalWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
}
.muarBlock {
  width: 100%;
  height: 100%;
  position: absolute;
  backdrop-filter: blur(10px);
  background-size: cover;
  z-index: -1;
}
.formBlok {
  width: 400px;
}
</style>
